/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FeatureRepresentation,
  LicenseFeatureRequest,
  LicenseRepresentation,
  TokenRepresentation,
} from '../models/index';
import {
    FeatureRepresentationFromJSON,
    FeatureRepresentationToJSON,
    LicenseFeatureRequestFromJSON,
    LicenseFeatureRequestToJSON,
    LicenseRepresentationFromJSON,
    LicenseRepresentationToJSON,
    TokenRepresentationFromJSON,
    TokenRepresentationToJSON,
} from '../models/index';

export interface AddLicenseFeatureRequest {
    key: string;
    licenseFeatureRequest?: LicenseFeatureRequest;
}

export interface GetAccountSettingsUrlRequest {
    lang: string;
}

export interface GetLicenseRequest {
    key: string;
}

export interface GetTokenRequest {
    stt?: string;
}

export interface RemoveLicenseRequest {
    key: string;
}

export interface RemoveLicenseFeatureRequest {
    key: string;
    featkey: string;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Add a feature to an existing license key
     * Add a feature
     */
    async addLicenseFeatureRaw(requestParameters: AddLicenseFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling addLicenseFeature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/licenses/{key}/features`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseFeatureRequestToJSON(requestParameters['licenseFeatureRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a feature to an existing license key
     * Add a feature
     */
    async addLicenseFeature(key: string, licenseFeatureRequest?: LicenseFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addLicenseFeatureRaw({ key: key, licenseFeatureRequest: licenseFeatureRequest }, initOverrides);
    }

    /**
     * Create a new license
     * Create a new license
     */
    async createLicenseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/licenses`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new license
     * Create a new license
     */
    async createLicense(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRepresentation> {
        const response = await this.createLicenseRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the url for the account settings page
     * Get account settings url
     */
    async getAccountSettingsUrlRaw(requestParameters: GetAccountSettingsUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['lang'] == null) {
            throw new runtime.RequiredError(
                'lang',
                'Required parameter "lang" was null or undefined when calling getAccountSettingsUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/account/settingsurl`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get the url for the account settings page
     * Get account settings url
     */
    async getAccountSettingsUrl(lang: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAccountSettingsUrlRaw({ lang: lang }, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of all available features for licenses
     * Get all features
     */
    async getFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/features`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureRepresentationFromJSON));
    }

    /**
     * Get a list of all available features for licenses
     * Get all features
     */
    async getFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureRepresentation>> {
        const response = await this.getFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get license data for a license key
     * Get license information
     */
    async getLicenseRaw(requestParameters: GetLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/licenses/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseRepresentationFromJSON(jsonValue));
    }

    /**
     * Get license data for a license key
     * Get license information
     */
    async getLicense(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRepresentation> {
        const response = await this.getLicenseRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of all licenses.
     * Get all licenses
     */
    async getLicensesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LicenseRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/licenses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LicenseRepresentationFromJSON));
    }

    /**
     * Get a list of all licenses.
     * Get all licenses
     */
    async getLicenses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LicenseRepresentation>> {
        const response = await this.getLicensesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Exchange and refresh (if necessary) access token for secret provided as httpOnly cookie
     * Get or update token
     */
    async getTokenRaw(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenRepresentation>> {
        const queryParameters: any = {};

        if (requestParameters['stt'] != null) {
            queryParameters['stt'] = requestParameters['stt'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/token`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenRepresentationFromJSON(jsonValue));
    }

    /**
     * Exchange and refresh (if necessary) access token for secret provided as httpOnly cookie
     * Get or update token
     */
    async getToken(stt?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenRepresentation> {
        const response = await this.getTokenRaw({ stt: stt }, initOverrides);
        return await response.value();
    }

    /**
     * Logout, delete a token and current active cookie
     * Logout
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/token`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout, delete a token and current active cookie
     * Logout
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutRaw(initOverrides);
    }

    /**
     * Remove a license
     * Remove a license
     */
    async removeLicenseRaw(requestParameters: RemoveLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/licenses/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a license
     * Remove a license
     */
    async removeLicense(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLicenseRaw({ key: key }, initOverrides);
    }

    /**
     * Remove a feature from an existing license
     * Remove a feature
     */
    async removeLicenseFeatureRaw(requestParameters: RemoveLicenseFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeLicenseFeature().'
            );
        }

        if (requestParameters['featkey'] == null) {
            throw new runtime.RequiredError(
                'featkey',
                'Required parameter "featkey" was null or undefined when calling removeLicenseFeature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/licenses/{key}/features/{featkey}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));
        urlPath = urlPath.replace(`{${"featkey"}}`, encodeURIComponent(String(requestParameters['featkey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a feature from an existing license
     * Remove a feature
     */
    async removeLicenseFeature(key: string, featkey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLicenseFeatureRaw({ key: key, featkey: featkey }, initOverrides);
    }

}
